import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const BottomModalDesignComponent = (props) => {
    const { t } = useTranslation()
    const toggleModal = props.togglebottomModal;
    const evtconfirmClick = props.confirmclick;
    const type = props.popuptype;
    const loading = props?.loading;
    const success = props?.success;
    const cancelClick = props?.cancelClick

    const closeModal = () => {
        // console.log(`close modal...`);
        toggleModal();
    };

    const confirmClick = () => {
        evtconfirmClick();
    };



    return (
        <Modal show={props.show} onHide={closeModal} className="bottom_modal animated  slideInUp faster">
            <Modal.Body className="text-center">
                {/* <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title="" />
          </div> */}
                <div className="bottom_popup_main">
                    <div className="title_comp">
                        <div className="heading">
                            <h6 className="main_title">Manage Roaming</h6>
                            <img src={process.env.PUBLIC_URL + "/assets/images/cross_dark.svg"} alt="" />
                        </div>
                        <div className="support_txt">
                            <p>Enable and disable roaming services.</p>
                        </div>
                    </div>
                    <hr />
                    <div className="toggle_component">
                    <div className="toggle_section">
                        <div className="toggle_title">
                            <h6 className="toggle_title_txt">International Calling</h6>
                            <div class="cs_toggle_btn action_grp">
                                <input type="checkbox" name="toggle" id="1" checked="" />
                                <label for="1">&nbsp;</label></div>
                        </div>
                        <div className="section_summary mt-2">
                            Price per country Activate your international call service to call and SMS your friends and family outside Kuwait anytime.
                        </div>
                    </div>
                    <hr />
                    <div className="toggle_section">
                        <div className="toggle_title">
                            <h6 className="toggle_title_txt">Roaming Services</h6>
                            <div class="cs_toggle_btn action_grp">
                                <input type="checkbox" name="toggle" id="1" checked="" />
                                <label for="1">&nbsp;</label></div>
                        </div>
                        <div className="section_summary mt-2">
                            When you activate the roaming service you will receive 20 incoming roaming minutes for non-passport countries. 2GB high-Speed FUP for passport countries, for 3KD per day, if you don’t have an active roaming pack.
                        </div>
                    </div>
                    <hr />
                    <div className="toggle_section">
                        <div className="toggle_title">
                            <h6 className="toggle_title_txt">Roaming Services</h6>
                            <div class="cs_toggle_btn action_grp">
                                <input type="checkbox" name="toggle" id="1" checked="" />
                                <label for="1">&nbsp;</label></div>
                        </div>
                        
                        <div className="section_summary">
                            <h6>Passport Turkey</h6>
                            When you activate the roaming service you will receive 20 incoming roaming minutes for non-passport countries. 2GB high-Speed FUP for passport countries, for 3KD per day, if you don’t have an active roaming pack.
                        </div>
                    </div>
                    </div>
                    <hr />
                    <div className="chat_support">
                        <p>
                            In case if you cannot connect to network, try connecting manually
                        </p>
                        <p>
                            For any other assistance contact <span>Chat Support</span>
                        </p>
                    </div>
                </div>
                <p className="modal_p">{props.message}</p>
                <div className='flex_grp_align_center mt-4'>
                    {/* <button type="button" className="custom_btn custom_btn_primary_outline btn_block me-2"
                        onClick={closeModal}>{t("cancel")}</button> */}
                    <button type="button" className="custom_btn custom_btn_primary btn_block ms-2"
                        onClick={confirmClick}>{t("confirm")}</button>
                </div>

            </Modal.Body>
        </Modal>
    );

};
export default BottomModalDesignComponent;